module.exports = __webpack_public_path__ + "img/bq.d1c60c62.svg";